import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

function ArtistCard(props) {
  const dispatch = useDispatch()
  const favorites = useSelector(state => state.favoritReducer.favorites)
  // const [alreadyAdded, setAlreadyAdded] = useState(false)

  const addFavorite = () => {
    let isAdded = false
    favorites.forEach(el => {
      if (el.strArtist === props.artist.strArtist) {
        isAdded = true
      }
    })
    if (!isAdded) {
      dispatch({
        type: "ADD_FAVORITE",
        payload: props.artist
      })
    }
  }

  const alreadyAdded = () => {
    let added = false
    favorites.forEach(el => {
      if (el.strArtist === props.artist.strArtist) {
        added = true
      }
    })
    return (
      added
    )
  }

  return (
    <div>
      <div className="container border rounded mt-3 p-2">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="col">
              <div className="card-header border-0">
                <img className="img-responsive img-responsive" src={props.artist.strArtistLogo} alt={props.artist.strArtist} style={{ height: "100px" }} />
                <p className="card-text"><small className="text-muted"> {props.artist.strArtist} logo</small></p>
                <div
                  className="cardAlbum2 containerscard"
                  style={{
                    backgroundImage: `url(${props.artist.strArtistThumb})`
                  }}
                ></div>
                <p className="card-text"><small className="text-muted"> {props.artist.strArtist} thumbnail</small></p>
              </div>
            </div>
            <div className="col">
              <ul className="list-group list-group-flush rounded" id="colorsthis">
                <li className="list-group-item"><b> origin : </b> {props.artist.strCountry}</li>
                <li className="list-group-item"><b> label : </b> {props.artist.strLabel}</li>
                <li className="list-group-item"><b> formed : </b> {props.artist.intFormedYear}</li>
                <li className="list-group-item"><b> genre : </b> {props.artist.strGenre}</li>
              </ul>
            </div>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-12">
            {!alreadyAdded() &&
              <button
                onClick={addFavorite}
                className="btn btn-outline-light my-2 my-sm-0">add favorites</button>}
            {alreadyAdded() &&
              <button
                className="btn btn-outline-light my-2 my-sm-0" disabled>favorites</button>}
            <div className="card-block px-2">
              <h2 className="card-title">{props.artist.strArtist} </h2>
              <p dangerouslySetInnerHTML={{ __html: props.artist.strBiographyEN }} className="card-text bgcols rounded p-2"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArtistCard
